'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * The TextInput component with floating label capability
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * If the parent using this component wants to mutate the input value,
                                                                                                                                                                                                                                                                   * that parent must implement its own function passed as a prop {this.props.handleChange},
                                                                                                                                                                                                                                                                   * which returns the value to be set in this component state.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Floating Label design pattern
                                                                                                                                                                                                                                                                   * http://www.google.com/design/spec/components/text-fields.html#text-fields-floating-labels
                                                                                                                                                                                                                                                                   * http://bradfrost.com/blog/post/float-label-pattern/
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _browserWurfl = require('browser-wurfl');

var _browserWurfl2 = _interopRequireDefault(_browserWurfl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLORS = {
	blue: '#0070ba',
	gray: '#6c7378'
};

var STYLES = {
	textInput: {
		width: '100%',
		height: 'auto',
		padding: 0,
		margin: '10px 0',
		position: 'relative',
		display: 'table',
		tableLayout: 'fixed'
	},

	placeholder: {
		padding: 0,
		position: 'absolute',
		top: 10,
		left: 10,
		color: COLORS.gray,
		fontSize: 15,
		lineHeight: '20px',

		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out',

		WebkitTransform: 'translate3d(0,0,0)',
		MozTransform: 'translate3d(0,0,0)',
		msTransform: 'translate3d(0,0,0)',
		OTransform: 'translate3d(0,0,0)',
		transform: 'translate3d(0,0,0)',

		WebkitTransformOrigin: 'left top',
		MozTransformOrigin: 'left top',
		msTransformOrigin: 'left top',
		OTransformOrigin: 'left top',
		transformOrigin: 'left top'
	},

	floatLabel: {
		color: COLORS.blue,
		WebkitTransform: 'translate(1px, -5px) scale(0.75)',
		MozTransform: 'translate(1px, -5px) scale(0.75)',
		msTransform: 'translate(1px, -5px) scale(0.75)',
		OTransform: 'translate(1px, -5px) scale(0.75)',
		transform: 'translate(1px, -5px) scale(0.75)'
	},

	input: {
		width: '100%',
		height: 40,
		padding: 10,
		margin: 0,
		display: 'table-cell',
		boxSizing: 'border-box',
		border: '1px solid',
		borderColor: COLORS.gray,
		borderRadius: 5,
		background: '#fff',
		fontSize: 15,
		lineHeight: '20px',

		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

var TextInput = _react2.default.createClass({
	displayName: 'TextInput',

	propTypes: {
		className: _react2.default.PropTypes.string,
		label: _react2.default.PropTypes.string,
		helpText: _react2.default.PropTypes.string,

		type: _react2.default.PropTypes.string,
		name: _react2.default.PropTypes.string.isRequired,
		id: _react2.default.PropTypes.string.isRequired,
		dataAttributes: _react2.default.PropTypes.object,

		autocomplete: _react2.default.PropTypes.string,
		dir: _react2.default.PropTypes.string,
		disabled: _react2.default.PropTypes.bool,
		max: _react2.default.PropTypes.number,
		maxlength: _react2.default.PropTypes.number,
		min: _react2.default.PropTypes.number,
		minlength: _react2.default.PropTypes.number,
		pattern: _react2.default.PropTypes.string,
		readonly: _react2.default.PropTypes.bool,
		required: _react2.default.PropTypes.bool,

		value: _react2.default.PropTypes.string,
		handleChange: _react2.default.PropTypes.func,
		handleFocus: _react2.default.PropTypes.func,
		handleBlur: _react2.default.PropTypes.func
	},

	/**
  * Get default props just in case they're not provided
  *
  * handleChange() should be implemented by the parent using this component,
  * but if it's not, we should just return the value passed in
  */
	getDefaultProps: function getDefaultProps() {
		return {
			type: 'text',
			readonly: false,
			handleChange: function handleChange(value) {
				return value;
			},
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},


	/**
  * Get the initial component state
  *
  * If there is already a value in the input, we want to float the label
  */
	getInitialState: function getInitialState() {
		return {
			hovered: false,
			focused: false,
			floatLabel: !!this.props.value,
			value: this.props.value || '',
			placeholder: ''
		};
	},


	/**
  * Clear the timeout when we're about to unmount
  */
	componentWillUnmount: function componentWillUnmount() {
		clearTimeout(this._timeoutID);
	},
	handleMouseOver: function handleMouseOver() {
		this.setState({ hovered: true });
	},
	handleMouseOut: function handleMouseOut() {
		this.setState({ hovered: false });
	},


	/**
  * Float the label on focus
  */
	handleFocus: function handleFocus() {
		var _this = this;

		this.setState({
			focused: true,
			floatLabel: true
		});

		// wait until the label floating up animation is done before we show the placeholder
		this._timeoutID = setTimeout(function () {
			if (_this.state.floatLabel && !!_this.props.label) {
				_this.setState({
					placeholder: _this.props.helpText
				});
			}
		}, 375);

		this.props.handleFocus(this.state.value);
	},


	/**
  * Don't float the label on blur, but keep it floated if there's an input value
  */
	handleBlur: function handleBlur() {
		this.setState({
			focused: false,
			floatLabel: !!this.state.value,
			placeholder: ''
		});

		this.props.handleBlur(this.state.value);
	},


	/**
  * Handle change on the text input
  * Call this.props.handleChange and pass the input value
  * this.props.handleChange should return some value to be set in the state
  * For some use cases, like autofill, we should float the lable if the input has any value
  */
	handleChange: function handleChange(event) {
		var value = this.props.handleChange(event.target.value);

		this.setState({
			value: value,
			floatLabel: !!value || this.state.focused
		});
	},


	/**
  * Clear the input and focus after clearing the value in the state
  */
	clearAndFocusInput: function clearAndFocusInput() {
		var _this2 = this;

		this.setState({
			value: ''
		}, function () {
			return _this2._input.focus();
		});
	},


	/**
  * Renders the clear input button for touch devices not on IE>10 where -ms-clear is used
  * @return {ReactElement} clear input button
  */
	renderClearInput: function renderClearInput() {
		if (_browserWurfl2.default.canShowClearInput && this.state.value) {
			return _react2.default.createElement('div', { className: 'clearInput icon-close-small', onClick: this.clearAndFocusInput });
		}

		return null;
	},
	render: function render() {
		var _this3 = this;

		var IS_VX = !!(this.props.className && this.props.className.includes('vx_'));
		var shouldFloatLabel = this.state.floatLabel && !!this.props.label;

		// text input wrapper styles
		var textInputStyles = IS_VX ? { position: 'relative' } : STYLES.textInput;

		// add the floated label styles if the label sholuld be floated
		var labelStyles = STYLES.placeholder;
		if (shouldFloatLabel) {
			labelStyles = _extends({}, labelStyles, STYLES.floatLabel, {
				color: this.state.focused ? COLORS.blue : COLORS.gray
			});
		}

		// move the actual inuput down when the label is floated
		// change the border color based on if the text input should be highlighted
		var borderColor = this.state.hovered || this.state.focused ? COLORS.blue : COLORS.gray;
		var inputStyles = {};
		if (!IS_VX) {
			inputStyles = _extends({}, inputStyles, STYLES.input);
		}
		inputStyles = _extends({}, inputStyles, {
			padding: shouldFloatLabel ? '14px 10px 0' : 10,
			borderColor: borderColor
		});

		// decide if handle when input is read only
		var shouldHandle = function shouldHandle(handler) {
			if (_this3.props.readonly === false) {
				return handler;
			}
		};

		return _react2.default.createElement(
			'div',
			_extends({ className: this.props.className, style: textInputStyles }, this.props.dataAttributes),
			_react2.default.createElement(
				'label',
				{ htmlFor: this.props.id, style: labelStyles },
				this.props.label
			),
			_react2.default.createElement('input', { ref: function ref(c) {
					return _this3._input = c;
				},
				type: this.props.type,
				name: this.props.name,
				id: this.props.id,
				placeholder: this.state.placeholder,
				value: this.state.value,

				autoComplete: this.props.autocomplete,
				dir: this.props.dir,
				disabled: this.props.disabled,
				max: this.props.max,
				maxLength: this.props.maxlength,
				min: this.props.min,
				minLength: this.props.minlength,
				pattern: this.props.pattern,
				readOnly: this.props.readonly,
				required: this.props.required,
				'aria-label': this.props.label,

				style: inputStyles,

				onMouseOver: shouldHandle(this.handleMouseOver),
				onMouseOut: shouldHandle(this.handleMouseOut),
				onFocus: shouldHandle(this.handleFocus),
				onBlur: shouldHandle(this.handleBlur),
				onChange: shouldHandle(this.handleChange)
			}),
			_react2.default.createElement('span', { className: 'vx_form-control-error-icon icon icon-small icon-critical-small' }),
			this.renderClearInput()
		);
	}
});

exports.default = TextInput;


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-text-input/dist/index.js
// module id = 355
// module chunks = 6